import { useMutation, useQuery } from '@tanstack/react-query';

import { type ApiKeyContent, ApiKeyRequester } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const requester = new ApiKeyRequester({ host: env.cerberusHost });

const QUERY_KEY = 'API_KEYS';

const useGetApiKeys = () =>
  useQuery<ApiKeyContent[]>({
    queryKey: [QUERY_KEY, 'GET_API_KEYS'],
    queryFn: () => requester.getApiKeys(),
  });

const useGenerateNewApiKey = () =>
  useMutation<string, unknown, { apiKeyName: string }>({
    mutationFn: (variables) => requester.generateNewApiKey(variables.apiKeyName),
  });

const useRevokeApiKey = () =>
  useMutation<void, unknown, { apiKeyPrefix: string }>({
    mutationFn: (variables) => requester.revokeApiKey(variables.apiKeyPrefix),
  });

export { useGetApiKeys, useGenerateNewApiKey, useRevokeApiKey };
